export default {
  table: {
    noData: 'لا توجد بيانات متاحة',
    loading: 'جاري التحميل...',
    search: 'بحث',
    filter: 'تصفية',
    export: 'تصدير',
    actions: 'الإجراءات',
    selectAll: 'تحديد الكل',
    deselectAll: 'إلغاء تحديد الكل',
    selected: 'محدد',
    items: 'عناصر',
    showing: 'عرض',
    to: 'إلى',
    of: 'من',
    results: 'نتائج',
    perPage: 'لكل صفحة'
  },
  pagination: {
    previous: 'السابق',
    next: 'التالي',
    first: 'الأول',
    last: 'الأخير',
    page: 'صفحة',
    of: 'من'
  },
  modal: {
    close: 'إغلاق',
    confirm: 'تأكيد',
    cancel: 'إلغاء'
  },
  form: {
    required: 'هذا الحقل مطلوب',
    invalid: 'قيمة غير صحيحة',
    submit: 'إرسال',
    reset: 'إعادة تعيين',
    cancel: 'إلغاء'
  },
  alert: {
    success: 'نجاح',
    error: 'خطأ',
    warning: 'تحذير',
    info: 'معلومة'
  },
  select: {
    placeholder: 'اختر خياراً...',
    noResults: 'لم يتم العثور على نتائج',
    search: 'بحث...'
  },
  datePicker: {
    selectDate: 'اختر التاريخ',
    today: 'اليوم',
    clear: 'مسح'
  },
  fileUpload: {
    selectFile: 'اختر ملف',
    dragDrop: 'اسحب وأفلت الملفات هنا',
    upload: 'رفع',
    remove: 'إزالة',
    maxSize: 'الحد الأقصى لحجم الملف',
    allowedTypes: 'أنواع الملفات المسموحة'
  }
}

